/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateMtaRiskChangeDto = {
    /**
     * Type of change
     */
    changeType: UpdateMtaRiskChangeDto.changeType;
    /**
     * Risk UUID (required for modify/remove)
     */
    riskId?: string | null;
    /**
     * Risk type
     */
    riskType: UpdateMtaRiskChangeDto.riskType;
    /**
     * Risk description
     */
    description: string;
    /**
     * Sum insured
     */
    sumInsured: number;
    /**
     * Excess
     */
    excess: number;
    /**
     * Excess value mapping based on Ando
     */
    excess_value: number;
    /**
     * Address
     */
    address?: string | null;
    /**
     * Offering identifier
     */
    offering?: string | null;
    /**
     * Specific details (risk_details blob from Ando)
     */
    specificDetails?: Record<string, any> | null;
    /**
     * Quote style risk object
     */
    quoteStyleRiskObject?: Record<string, any> | null;
};
export namespace UpdateMtaRiskChangeDto {
    /**
     * Type of change
     */
    export enum changeType {
        ADD = 'add',
        MODIFY = 'modify',
        REMOVE = 'remove',
    }
    /**
     * Risk type
     */
    export enum riskType {
        HOUSE = 'HOUSE',
        CONTENTS = 'CONTENTS',
        VEHICLE = 'VEHICLE',
    }
}

